import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './App'
import frFR from 'antd/lib/locale-provider/fr_FR'
import registerServiceWorker from './registerServiceWorker'
import {ConnectedRouter} from 'connected-react-router'
import {history, store} from './app.store'
import {ConfigProvider} from 'antd'
import {Provider} from 'react-redux'
import {START} from './app.actions'
import './index.css'

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ConfigProvider locale={frFR}>
        <App/>
      </ConfigProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement
)
registerServiceWorker()

store.dispatch({type: START})



// WEBPACK FOOTER //
// ./src/index.tsx